import { useTranslation } from "react-i18next";

// عنوان قسم + شبكة حقول — تُستخدم في أقسام نموذج المادة.
export const Section = ({ title, hint, tinted = false, cols = 2, children, testid }) => (
  <section data-testid={testid}
           className={`grid gap-3 rounded-2xl p-4 ${tinted ? "bg-emerald-500/5 shadow-neu-in" : "border-t border-border/60 pt-5"}`}>
    {title ? (
      <p className="text-sm font-bold">
        {title}{hint ? <span className="ms-2 text-[11px] font-normal text-muted-foreground">{hint}</span> : null}
      </p>
    ) : null}
    <div className={`grid gap-4 ${cols === 3 ? "sm:grid-cols-3" : "sm:grid-cols-2"}`}>{children}</div>
  </section>
);

export const Field = ({ label, required, hint, children, className = "" }) => (
  <div className={`grid content-start gap-1.5 ${className}`}>
    <span className="text-[11px] font-bold text-muted-foreground">{label}{required ? " *" : ""}</span>
    {children}
    {hint ? <span className="text-[10px] text-muted-foreground">{hint}</span> : null}
  </div>
);

// حقل للقراءة فقط بمظهر غائر (كود المادة · الحسابات المحاسبية).
export const ReadOnly = ({ value, placeholder, testid }) => {
  const { i18n } = useTranslation();
  return (
    <div data-testid={testid} dir={value ? "ltr" : i18n.dir()}
         className={`num flex h-12 w-full items-center rounded-2xl border border-border/60 bg-background px-4 text-sm shadow-neu-in ${value ? "" : "text-muted-foreground/70"}`}>
      {value || placeholder}
    </div>
  );
};
